export enum WeightUnit {
    Kilogram = 'kg',
    Plant = 'pl',
    Units = 'ud'
};
